/**
 * @file DiseaseManagement.js
 * @description This file contains the SickleMedication component.
 * @author Nadeem Ahamad
 * @since 2025-06-20
 */
import React, { useEffect, useState, useCallback } from "react";
import { sickleAPI } from "../../../services/sickle.api";
import Loader from "../../../components/Loader";
import { Collapse } from 'bootstrap';
import { toast } from "react-toastify";

const DiseaseManagement = ({ onClose, sickleId, patientTestDetails }) => {

    const [accordianDisabled, setAccordianDisabled] = useState(true);
    const [drugList, setDrugList] = useState([]);
    const [vaccineDose, setVaccineDose] = useState("");
    const [patientProfile, setProfileProfiles] = useState([]);
    const [bloodGroups, setBloodGroups] = useState([]);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [treatmentId, setTreatmentId] = useState("");
    const [visitId, setvisitId] = useState("");
    const [diseaseID] = useState(1);
    const [medicineErrors, setMedicineErrors] = useState({});
    const [treatmentHfCount, setTreatmentHfCount] = useState(0);
    const [labTestsList, setLabTestsList] = useState([]);
    const [labTestResults, setLabTestResults] = useState([]);
    const [labErrors, setLabErrors] = useState({});
    const [bloodErrors, setbloodErrors] = useState({});
    const [vaccineNames, setVaccineNames] = useState([]);
    const [vaccineErrors, setVaccineErrors] = useState([]);

    const userDetails = JSON.parse(localStorage.getItem('loggedinUserdetails'));

    const [medicineForm, setMedicineForm] = useState({
        quantity_prescribed: "",
        quantity_dispensed: "",
        treatment_id: treatmentId,
        sickle_id: sickleId,
        drug_snomed: "",
        drug_id: "",
        drug_name: "",
        visit_no: visitId,
        disease_id: diseaseID,
        date_dispensed: "",
        date_prescibed: "",
        incharge_mobile: userDetails?.InchargeMobile,
        incharge_hf_id: userDetails?.facilityTypeId,
        source: 1,
        hf_name_dispensed: "Baharawati",
        hf_id_dispensed: "410561",
        hf_name_prescribed: "Baharawati",
        hf_id_prescribed: "410561"
    });

    const [labInvestigationForm, setlabInvestigationForm] = useState({
        treatment_id: treatmentId,
        sickle_id: sickleId,
        disease_id: diseaseID,
        visit_no: visitId,
        test_id: "",
        test_snomed: "",
        test_name: "",
        sample_collection_date: "",
        result_date: "",
        result_id: "",
        result_snomed: "",
        test_done_in_hf_id: "410561",
        test_done_in_hf_name: "Baharawati",
        incharge_mobile: userDetails?.InchargeMobile,
        incharge_hf_id: userDetails?.facilityTypeId,
        source: "mob_app"
    });

    const [bloodTransfusionForm, setbloodTransfusionForm] = useState({
        treatment_id: treatmentId,
        sickle_id: sickleId,
        disease_id: diseaseID,
        visit_no: visitId,
        transfusion_date: "",
        transfusion_hf_id: 413399,
        transfusion_hf_name: "Blood bank Agra AMMS",
        incharge_mobile: userDetails?.InchargeMobile,
        incharge_hf_id: userDetails?.facilityTypeId,
        source: "mob_app"
    });

    const [vaccineForm, setVaccineForm] = useState({
        treatment_id: treatmentId,
        sickle_id: sickleId,
        disease_id: diseaseID,
        visit_no: visitId,
        vaccine_id: "",
        vaccine_snomed: "",
        vaccine_name: "",
        dose_id: "",
        dose_name: "",
        vaccination_date: "",
        next_vaccine_date: "",
        vaccination_hf_id: "413399",
        vaccination_hf_name: "Kanpur AMMS",
        incharge_mobile: userDetails?.InchargeMobile,
        incharge_hf_id: userDetails?.facilityTypeId,
        source: "mob_app"
    });

    /**
     * This function is used to get the diseased beneficiaries.
     * 
     */

    const getBeneficiaries = useCallback(async () => {
        setIsPageLoading(true);
        try {
            const payload = {
                sickle_id: sickleId,
                disease_type: 1
            };
            const resp = await sickleAPI.getDiseasedBeneficiaries(payload);
            if (resp.status === 1) {
                if (resp?.PatientDetails?.length > 0) {
                    setProfileProfiles(resp?.PatientDetails[0]);
                    setIsPageLoading(false);
                } else {
                    toast.error("Beneficiaries diseased not found! Please do any test")
                }
            } else {
                setIsPageLoading(false);
                toast.error("Data not found");
            }
        } catch (error) {
            console.error("Error in get Diseased Beneficiaries: ", error);
        }
    }, [sickleId]);

    /**
     * This function is used to get the blood groups.
     */
    const fetchBloodGroups = async () => {
        setIsPageLoading(true);
        try {
            const resp = await sickleAPI.getBloodGroups();
            if (resp.status === 1) {
                const dtbloodgroups = resp?.BloodGroups || [];
                setBloodGroups(dtbloodgroups);
                setIsPageLoading(false);
            } else {
                setIsPageLoading(false);
                toast.error("Blood groups not found");
            }

        } catch (error) {
            setIsPageLoading(false);
            toast.error("Error in getPatientRegDetails:", error);
        }
    };

    /**
     * This function is used to get the drug List
     */
    const fetchDrugList = async () => {
        setIsPageLoading(true);
        try {
            const resp = await sickleAPI.getDrugList(1);
            if (resp.status === 1) {
                setDrugList(resp.ResultType);
                setIsPageLoading(false);
            } else {
                setIsPageLoading(false);
                toast.error("drug list not found");
            }

        } catch (error) {
            setIsPageLoading(false);
            toast.error("Error in drug list:", error);
        }
    };

    /**
     * This function is used to get the blood groups.
     */
    const fetchLabTestsList = async () => {

        setIsPageLoading(true);
        try {
            const resp = await sickleAPI.getLabTests();
            if (resp.status === 1) {
                setLabTestsList(resp.ResultType);
                setIsPageLoading(false);
            } else {
                setIsPageLoading(false);
                toast.error("Lab test not found");
            }

        } catch (error) {
            setIsPageLoading(false);
            toast.error("Error in lab test fetching :", error);
        }
    };

    /**
     * This function is used to get the blood groups.
     */
    const fetchVaccineNames = async () => {

        setIsPageLoading(true);
        try {
            const resp = await sickleAPI.getVaccineNames();
            if (resp.status === 1) {
                setVaccineNames(resp.ResultType);
                setIsPageLoading(false);
            } else {
                setIsPageLoading(false);
                toast.error("Vaccine master not found");
            }

        } catch (error) {
            setIsPageLoading(false);
            toast.error("Error in vaccine master fetching :", error);
        }
    };

    useEffect(() => {
        fetchBloodGroups();
        getBeneficiaries();
        fetchDrugList();
        fetchLabTestsList();
        fetchVaccineNames();
    }, [getBeneficiaries]);

    /**
    * This function is used to add the medicine.
    * @param {*} params 
    */
    const handleConfirm = async () => {
        setIsPageLoading(true);
        const instanceData = JSON.parse(localStorage.getItem('instanceData'));
        if (!instanceData) {
            const payload = {
                sickle_id: Number(sickleId),
                disease_id: diseaseID,
                incharge_mobile: userDetails?.InchargeMobile,
                incharge_hf_id: userDetails?.facilityTypeId,
            };
            const dtResponse = await sickleAPI.createTreatmentInstance(payload);
            if (dtResponse.status === 1) {
                localStorage.setItem('instanceData', JSON.stringify(dtResponse));
                setTreatmentId(dtResponse.treatment_id);
                setvisitId(dtResponse.visit_id);
                setTreatmentHfCount(dtResponse.treatment_hf_count);
                setTimeout(() => {
                    setIsPageLoading(false);
                    setAccordianDisabled(false);
                    const profileEl = document.getElementById('collapseProfile');
                    const medicineEl = document.getElementById('collapseMedicine');

                    if (profileEl && profileEl.classList.contains('show')) {
                        const profileCollapse = Collapse.getInstance(profileEl) || new Collapse(profileEl, { toggle: false });
                        profileCollapse.hide();
                    }

                    if (medicineEl && !medicineEl.classList.contains('show')) {
                        const medicineCollapse = Collapse.getInstance(medicineEl) || new Collapse(medicineEl, { toggle: false });
                        medicineCollapse.show();
                    }
                }, 3000);
            } else {
                setIsPageLoading(false);
                toast.error("error in create instance");
            }
        } else {
            setTreatmentId(instanceData.treatment_id);
            setvisitId(instanceData.visit_id);
            setTreatmentHfCount(instanceData.treatment_hf_count);
            setTimeout(() => {
                setIsPageLoading(false);
                setAccordianDisabled(false);
                const profileEl = document.getElementById('collapseProfile');
                const medicineEl = document.getElementById('collapseMedicine');

                if (profileEl && profileEl.classList.contains('show')) {
                    const profileCollapse = Collapse.getInstance(profileEl) || new Collapse(profileEl, { toggle: false });
                    profileCollapse.hide();
                }

                if (medicineEl && !medicineEl.classList.contains('show')) {
                    const medicineCollapse = Collapse.getInstance(medicineEl) || new Collapse(medicineEl, { toggle: false });
                    medicineCollapse.show();
                }
            }, 3000);
        }
    }

    // Update form data on input change
    const medicineInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'drug_id') {
            const selectedDrug = drugList.find(item => item.drug_id === value);
            setMedicineForm({
                ...medicineForm,
                drug_id: value, // drug_id
                drug_name: selectedDrug ? selectedDrug.drug_name : '', // drug_name
                drug_snomed: selectedDrug ? selectedDrug.drug_snomed : '' // drug_name

            });
        } else {
            setMedicineForm({
                ...medicineForm,
                [name]: value, //drug_id
            });
        }
        // Clear error for the field as the user types
        setMedicineErrors({
            ...medicineErrors,
            [name]: '',
        });
    };

    // Update form data on input change
    const labInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'result_id') {
            const selectedResult = labTestResults.find(item => item.test_result_id === value);
            setlabInvestigationForm({
                ...labInvestigationForm,
                result_id: value, // drug_id
                result_snomed: selectedResult ? selectedResult.test_result_snomed : '' // drug_name

            });
        } else {
            setlabInvestigationForm({
                ...labInvestigationForm,
                [name]: value, //drug_id
            });
        }
        // Clear error for the field as the user types
        setLabErrors({
            ...labErrors,
            [name]: '',
        });
    };

    // Update form data on input change
    const bloodTrasfusionChange = (e) => {
        const { name, value } = e.target;

        setbloodTransfusionForm({
            ...bloodTransfusionForm,
            [name]: value,
        });
        // Clear error for the field as the user types
        setbloodErrors({
            ...bloodErrors,
            [name]: '',
        });
    };

    // Update form data on input change
    const vaccineInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'dose_id') {
            const selectedDose = vaccineDose.find(item => item.dose_id === value);
            setVaccineForm({
                ...vaccineForm,
                dose_id: value, // dose_id
                dose_name: selectedDose ? selectedDose.dose_name : '', // dose_name
                dose_snomed: selectedDose ? selectedDose.dose_snomed : '' // dose_snomed

            });
        } else {
            setVaccineForm({
                ...vaccineForm,
                [name]: value, //drug_id
            });
        }
        // Clear error for the field as the user types
        setVaccineErrors({
            ...vaccineErrors,
            [name]: '',
        });
    };

    useEffect(() => {
        console.log("patientTestDetails updated", patientTestDetails);
        console.log("userDetails updated: ", userDetails);
        console.log("vaccine form update", vaccineForm);
    }, [vaccineForm, patientTestDetails, userDetails]);

    useEffect(() => {
        setMedicineForm(prev => ({
            ...prev,
            visit_no: visitId, // visitId
            treatment_id: treatmentId, // treatmentId
        }));
        setlabInvestigationForm(prev => ({
            ...prev,
            visit_no: visitId, // visitId
            treatment_id: treatmentId, // treatmentId
        }));

        setbloodTransfusionForm(prev => ({
            ...prev,
            visit_no: visitId, // visitId
            treatment_id: treatmentId, // treatmentId
        }));

        setVaccineForm(prev => ({
            ...prev,
            visit_no: visitId, // visitId
            treatment_id: treatmentId, // treatmentId
        }));
    }, [visitId, treatmentId, treatmentHfCount]);

    const validateMedicineForm = () => {
        const newErrors = {};

        if (!medicineForm.drug_id?.trim()) {
            newErrors.drug_id = 'Drug ID is required';
        }

        if (!medicineForm.drug_name?.trim()) {
            newErrors.drug_name = 'Drug Name is required';
        }

        if (!medicineForm.quantity_prescribed?.trim()) {
            newErrors.quantity_prescribed = 'Quantity Prescribed is required';
        }

        if (!medicineForm.quantity_dispensed?.trim()) {
            newErrors.quantity_dispensed = 'Quantity Dispensed is required';
        }

        if (!medicineForm.date_prescibed?.trim()) {
            newErrors.date_prescibed = 'Prescribed Date is required';
        }

        if (!medicineForm.date_dispensed?.trim()) {
            newErrors.date_dispensed = 'Dispensed Date is required';
        }

        if (!medicineForm.incharge_mobile?.trim()) {
            newErrors.incharge_mobile = 'Incharge Mobile is required';
        }

        if (!medicineForm.incharge_hf_id?.toString().trim()) {
            newErrors.incharge_hf_id = 'Incharge HF ID is required';
        }

        if (!medicineForm.hf_name_dispensed?.trim()) {
            newErrors.hf_name_dispensed = 'HF Name Dispensed is required';
        }

        if (!medicineForm.hf_id_dispensed?.trim()) {
            newErrors.hf_id_dispensed = 'HF ID Dispensed is required';
        }

        if (!medicineForm.hf_name_prescribed?.trim()) {
            newErrors.hf_name_prescribed = 'HF Name Prescribed is required';
        }

        if (!medicineForm.hf_id_prescribed?.trim()) {
            newErrors.hf_id_prescribed = 'HF ID Prescribed is required';
        }

        if (!medicineForm.treatment_id?.toString().trim()) {
            newErrors.treatment_id = 'Treatment ID is required';
        }

        return newErrors;
    };

    const validateLabForm = () => {
        const newErrors = {};

        if (!labInvestigationForm.test_id?.trim()) {
            newErrors.test_id = 'Test name is required';
        }

        if (!labInvestigationForm.sample_collection_date?.trim()) {
            newErrors.sample_collection_date = 'Sample collection date is required';
        }

        if (!labInvestigationForm.result_date?.trim()) {
            newErrors.result_date = 'Result date is required';
        }

        if (!labInvestigationForm.result_id?.trim()) {
            newErrors.result_id = 'Test Result is required';
        }

        return newErrors;
    };

    const validateBloodForm = () => {
        const newErrors = {};

        if (!bloodTransfusionForm.transfusion_date?.trim()) {
            newErrors.transfusion_date = 'Transfusion date is required';
        }

        // if (!bloodTransfusionForm.transfusion_hf_id?.trim()) {
        //     newErrors.transfusion_hf_id = 'Center Name is required';
        // }

        return newErrors;
    };

    const validateVaccineForm = () => {
        const newErrors = {};

        if (!vaccineForm.vaccine_id?.trim()) {
            newErrors.vaccine_id = 'Vaccine name is required';
        }

        if (!vaccineForm.vaccination_date?.trim()) {
            newErrors.vaccination_date = 'Vaccination date is required';
        }

        if (!vaccineForm.next_vaccine_date?.trim()) {
            newErrors.next_vaccine_date = 'Next vaccination date is required';
        }

        if (!vaccineForm.dose_id?.trim()) {
            newErrors.dose_id = 'Dose is required';
        }

        return newErrors;
    };

    // Handle form submission
    const addMedicine = async (e) => {
        e.preventDefault();
        const formErrors = validateMedicineForm();

        if (Object.keys(formErrors).length === 0) {
            setIsPageLoading(true);
            const dtResponse = await sickleAPI.createMedicine(medicineForm);
            if (dtResponse.status === "1") {
                setIsPageLoading(false);
                toast.success(dtResponse.msg);
            } else {
                setIsPageLoading(false);
                toast.error(dtResponse.msg);
            }
        } else {
            // Set errors to display them to the user
            setMedicineErrors(formErrors);
        }
    };

    /**
     * This function is used to get the drug List
     */
    const fetchTestResults = async (e) => {
        const test_id = e.target.value;
        setIsPageLoading(true);
        try {
            const resp = await sickleAPI.getLabTestResults(test_id);
            if (resp.status === 1) {
                setLabTestResults(resp.ResultType);
                const selectedTest = labTestsList.find(item => item.test_id === test_id);
                setlabInvestigationForm({
                    ...labInvestigationForm,
                    test_id: test_id, // test_id
                    test_name: selectedTest ? selectedTest.test_name : '', // test_name
                    test_snomed: selectedTest ? selectedTest.test_snomed : '' // test_snomed

                });
                setLabErrors({
                    ...labErrors,
                    test_id: '',
                });
                setIsPageLoading(false);
            } else {
                setIsPageLoading(false);
                toast.error("Error in test result list");
            }

        } catch (error) {
            setIsPageLoading(false);
            toast.error("Error in test result list:", error);
        }
    };

    // Handle form submission
    const addLabInvestigation = async (e) => {
        e.preventDefault();
        const formErrors = validateLabForm();
        if (Object.keys(formErrors).length === 0) {
            setIsPageLoading(true);
            const dtResponse = await sickleAPI.createLabInvestigation(labInvestigationForm);
            if (dtResponse.status === "1") {
                setIsPageLoading(false);
                toast.success(dtResponse.msg);
            } else {
                setIsPageLoading(false);
                toast.error(dtResponse.msg);
            }
        } else {
            // Set errors to display them to the user
            setLabErrors(formErrors);
        }
    };

    /**
     * This function is used to get the drug List
     */
    const fetchVaccineDose = async (e) => {
        const vaccineId = e.target.value;
        setIsPageLoading(true);
        try {
            const resp = await sickleAPI.getVaccineDose(vaccineId);
            if (resp.status === 1) {
                setVaccineDose(resp.ResultType);
                const selectedVaccine = vaccineNames.find(item => item.vaccine_id === vaccineId);
                setVaccineForm({
                    ...vaccineForm,
                    vaccine_id: vaccineId, // test_id
                    vaccine_name: selectedVaccine ? selectedVaccine.vaccine_name : '', // test_name
                    vaccine_snomed: selectedVaccine ? selectedVaccine.vaccine_snomed : '' // test_snomed

                });
                setVaccineErrors({
                    ...vaccineErrors,
                    test_id: '',
                });
                setIsPageLoading(false);
            } else {
                setIsPageLoading(false);
                toast.error("Error in test result list");
            }

        } catch (error) {
            setIsPageLoading(false);
            toast.error("Error in test result list:", error);
        }
    };

    // Handle form submission
    const addBloodTransfusion = async (e) => {
        e.preventDefault();
        const formErrors = validateBloodForm();
        if (Object.keys(formErrors).length === 0) {
            setIsPageLoading(true);
            const dtResponse = await sickleAPI.createBloodTransfusion(bloodTransfusionForm);
            if (dtResponse.status === "1") {
                setIsPageLoading(false);
                toast.success(dtResponse.msg);
            } else {
                setIsPageLoading(false);
                toast.error(dtResponse.msg);
            }
        } else {
            // Set errors to display them to the user
            setbloodErrors(formErrors);
        }
    };

    // Handle form submission
    const addVaccine = async (e) => {
        e.preventDefault();
        const formErrors = validateVaccineForm();
        if (Object.keys(formErrors).length === 0) {
            setIsPageLoading(true);
            const dtResponse = await sickleAPI.createVaccine(vaccineForm);
            if (dtResponse.status === "1") {
                setIsPageLoading(false);
                toast.success(dtResponse.msg);
            } else {
                setIsPageLoading(false);
                toast.error(dtResponse.msg);
            }
        } else {
            // Set errors to display them to the user
            setVaccineErrors(formErrors);
        }
    };

    return (
        <>
            
            {isPageLoading && <Loader />}
            <div className="sickleMedicationSection">
                {/* <div className="sickleMedicationBoxRow">
                    <div className="sickelMedBox">
                        <div className="iconValue">
                            <img src={Tretment} />
                            <span className="value">20</span>
                        </div>
                        <p>Treatment count <br />by user in the HF.:</p>
                    </div>
                    <div className="sickelMedBox">
                        <div className="iconValue">
                            <img src={VisitNo} />
                            <span className="value">02</span>
                        </div>
                        <p>Visit No.:</p>
                    </div>
                </div> */}
                {/* ------------End Box Section----------- */}

                <div className="accordion" id="sickAccordion">
                    <div className="patientDetailsTitleHeader-h d-flex mb-0">
                        <div className="leftHeaderBar">
                            <span><img src={"/images/Sickel.svg"} alt="" style={{ width: "43px", margin:"10px 0 0 14px" }} /></span>
                            <h4>Sickle Disease Management</h4>
                        </div>
                        <div className="closeDive sickleclose" onClick={() => onClose('handleCloseSickleMedication')}><img src="/images/closing.svg" alt="Close" /></div>
                    </div>
                    {/* Patient Profile */}
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingProfile">
                            <button className="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseProfile" aria-expanded="true" aria-controls="collapseProfile">
                                Patient Profile
                            </button>
                        </h2>
                        <div id="collapseProfile" className="accordion-collapse collapse show" aria-labelledby="headingProfile" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">
                                {/* --- ORIGINAL Patient Profile tab content --- */}

                                <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                    <div className="tabsBodySickle">
                                        <div className="patientProfileSickelMedication medicationFeilds">
                                            <div className="medicationFeildsRow">
                                                <div className="feild">
                                                    <label>Sickle ID </label>
                                                    <input type="text" value={patientProfile?.sickle_id} disabled={true} />
                                                </div>

                                                <div className="feild">
                                                    <label>Registration Date</label>
                                                    <input type="text" value={patientProfile?.registration_date} disabled={true} />
                                                </div>

                                                <div className="feild">
                                                    <label>Blood Group </label>
                                                    <select value={patientProfile?.blood_group} disabled={true}>
                                                        <option>Select Blood Group</option>
                                                        {bloodGroups.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.bg_name}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div className="feild">
                                                    <label>Last Visit</label>
                                                    <input type="text" value={patientProfile?.last_visit ? patientProfile?.last_visit : 'N/A'} disabled={true} />
                                                </div>
                                            </div>
                                            <div className="ProceedtoTreatment mt-3">
                                                <h4>Proceed to  Treatment?</h4>
                                                <div className="ProceedTreatmentAction">
                                                    <button onClick={() => handleConfirm()}>Confirm</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Medicine */}
                    <div className={`accordion-item ${accordianDisabled ? 'disabled' : ''}`}>
                        <h2 className="accordion-header" id="headingMedicine">
                            <button
                                className={`accordion-button collapsed fw-bold ${accordianDisabled ? 'disabled' : ''}`} disabled={accordianDisabled} type="button" data-bs-toggle="collapse" data-bs-target="#collapseMedicine" aria-expanded="true" aria-controls="collapseMedicine">
                                Medicine <span className="Refre-red">*</span>
                            </button>
                        </h2>
                        <div id="collapseMedicine" className="accordion-collapse collapse" aria-labelledby="headingMedicine" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">
                                <div className="tabsBodySickle">
                                    <div className="patientProfileSickelMedication medicationFeilds">
                                        <div className="medicationFeildsRow">
                                            <div className="feild">
                                                <label>Drug Name</label>
                                                <select name="drug_id" onChange={medicineInputChange}>
                                                    <option value=''>Select Drug Name</option>
                                                    {drugList.map((item) => (
                                                        <option value={item.drug_id}>{item.drug_name}</option>
                                                    ))}
                                                </select>
                                                {medicineErrors.drug_id && <p style={{ color: 'red' }}>{medicineErrors.drug_id}</p>}
                                            </div>
                                            <div className="feild">
                                                <label>Quantity (Prescribed) </label>
                                                <input type="number" placeholder="Quantity " name="quantity_prescribed" onChange={medicineInputChange} />
                                                {medicineErrors.quantity_prescribed && <p style={{ color: 'red' }}>{medicineErrors.quantity_prescribed}</p>}
                                            </div>
                                            <div className="feild">
                                                <label>Quantity (Dispensed) </label>
                                                <input type="number" placeholder="Quantity " name="quantity_dispensed" onChange={medicineInputChange} />
                                                {medicineErrors.quantity_dispensed && <p style={{ color: 'red' }}>{medicineErrors.quantity_dispensed}</p>}

                                            </div>
                                            <div className="feild">
                                                <label>Date (Prescribed)</label>
                                                <input type="date" placeholder="20-03-2025 " min={'2025-06-20'} name="date_prescibed" onChange={medicineInputChange} />
                                                <p className="error-medicin">Minimum date: Confirmatory/Screening Result date(09-04-2025)</p>
                                                {medicineErrors.date_prescibed && <p style={{ color: 'red' }}>{medicineErrors.date_prescibed}</p>}
                                            </div>
                                            <div className="feild">
                                                <label>Date (Dispensed)</label>
                                                <input type="date" placeholder="20-03-2025 " name="date_dispensed" onChange={medicineInputChange} />
                                                {medicineErrors.date_dispensed && <p style={{ color: 'red' }}>{medicineErrors.date_dispensed}</p>}
                                            </div>
                                            <div className="feild field-25">
                                                <label>Centre Name (Medicine Prescribed) </label>
                                                <input type="text" placeholder="Prescribed Center" value={medicineForm.hf_name_prescribed} disabled={true} />
                                            </div>
                                            <div className="feild field-25">
                                                <label>Centre Name (Medicine Dispensed) </label>
                                                <input type="text" placeholder="Dispensed Center" value={medicineForm.hf_name_dispensed} disabled={true} />
                                            </div>

                                        </div>
                                        <div className="ProceedtoTreatment">
                                            <h4>Medicine Actions</h4>
                                            <div className="ProceedTreatmentAction">
                                                <button className="addMedication" onClick={addMedicine}>Add</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Lab Investigation */}
                    <div className={`accordion-item ${accordianDisabled ? 'disabled' : ''}`}>
                        <h2 className="accordion-header" id="headingLab">
                            <button className={`accordion-button collapsed fw-bold ${accordianDisabled ? 'disabled' : ''}`} disabled={accordianDisabled} type="button" data-bs-toggle="collapse" data-bs-target="#collapseLab" aria-expanded="false" aria-controls="collapseLab">
                                Lab Investigation<span className="Refre-red">*</span>
                            </button>
                        </h2>
                        <div id="collapseLab" className="accordion-collapse collapse" aria-labelledby="headingLab" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">
                                {/* --- ORIGINAL Lab Investigation tab content --- */}

                                <div className="tabsBodySickle">
                                    <div className="patientProfileSickelMedication medicationFeilds">
                                        <div className="medicationFeildsRow">
                                            <div className="feild">
                                                <label>Test Name</label>
                                                <select name="test_id" onChange={fetchTestResults}>
                                                    <option value="">Select Test Name</option>
                                                    {labTestsList && labTestsList.map((item, index) => (
                                                        <option key={index} value={item.test_id}>{item.test_name}</option>
                                                    ))}
                                                </select>
                                                {labErrors.test_id && <p style={{ color: 'red' }}>{labErrors.test_id}</p>}
                                            </div>
                                            <div className="feild field-19">
                                                <label>Date of Sample Collection</label>
                                                <input type="date" name="sample_collection_date" onChange={labInputChange} />
                                                <p className="error-medicin">Minimum date: Confirmatory/Screening Result date(09-04-2025)</p>
                                                {labErrors.sample_collection_date && <p style={{ color: 'red' }}>{labErrors.sample_collection_date}</p>}
                                            </div>
                                            <div className="feild">
                                                <label>Date of Result </label>
                                                <input type="date" name="result_date" onChange={labInputChange} />
                                                {labErrors.result_date && <p style={{ color: 'red' }}>{labErrors.result_date}</p>}
                                            </div>
                                            <div className="feild">
                                                <label>Test Result</label>
                                                <select name="result_id" onChange={labInputChange}>
                                                    <option>Select Result</option>
                                                    {labTestResults && labTestResults.map((item, index) => (
                                                        <option key={index} value={item.test_result_id}>{item.test_result_name}</option>
                                                    ))}
                                                </select>
                                                {labErrors.result_id && <p style={{ color: 'red' }}>{labErrors.result_id}</p>}
                                            </div>
                                            <div className="feild">
                                                <label>Lab Center Name </label>
                                                <input type="text" placeholder="Lab Center Name " disabled={true} value={labInvestigationForm.test_done_in_hf_name} />
                                            </div>

                                        </div>
                                        <div className="ProceedtoTreatment">
                                            <h4>Lab Investigation Actions</h4>
                                            <div className="ProceedTreatmentAction">
                                                <button className="addMedication" onClick={addLabInvestigation}>Add</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Blood Transfusion */}
                    <div className={`accordion-item ${accordianDisabled ? 'disabled' : ''}`}>
                        <h2 className="accordion-header" id="headingBlood">
                            <button className={`accordion-button collapsed fw-bold ${accordianDisabled ? 'disabled' : ''}`} disabled={accordianDisabled} type="button" data-bs-toggle="collapse" data-bs-target="#collapseBlood" aria-expanded="false" aria-controls="collapseBlood">
                                Blood Transfusion<span className="Refre-red">*</span>
                            </button>
                        </h2>
                        <div id="collapseBlood" className="accordion-collapse collapse " aria-labelledby="headingBlood" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">

                                <div className="tabsBodySickle">
                                    <div className="patientProfileSickelMedication medicationFeilds">
                                        <div className="medicationFeildsRow">

                                            <div className="feild field-19">
                                                <label>Date of Blood Transfusion</label>
                                                <input type="date" name="transfusion_date" onChange={bloodTrasfusionChange} />
                                                {bloodErrors.transfusion_date && <p style={{ color: 'red' }}>{bloodErrors.transfusion_date}</p>}
                                            </div>

                                            <div className="feild field-25">
                                                <label>Blood Transfusion Center Name</label>
                                                <select name="transfusion_hf_id" disabled={true} onChange={bloodTrasfusionChange}>
                                                    {/* <option value="">Select Center Name</option> */}
                                                    <option value={413399}>Blood bank Agra AMMS</option>
                                                </select>
                                                {bloodErrors.transfusion_hf_id && <p style={{ color: 'red' }}>{bloodErrors.transfusion_hf_id}</p>}
                                            </div>

                                        </div>
                                        <div className="ProceedtoTreatment">
                                            <h4>Blood Transfusion Actions</h4>
                                            <div className="ProceedTreatmentAction">
                                                <button className="addMedication" onClick={addBloodTransfusion}>Add</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Vaccination */}
                    <div className={`accordion-item ${accordianDisabled ? 'disabled' : ''}`}>
                        <h2 className="accordion-header" id="headingVaccination">
                            <button className={`accordion-button collapsed fw-bold ${accordianDisabled ? 'disabled' : ''}`} disabled={accordianDisabled} type="button" data-bs-toggle="collapse" data-bs-target="#collapseVaccination" aria-expanded="false" aria-controls="collapseVaccination">
                                Vaccination<span className="Refre-red">*</span>
                            </button>
                        </h2>
                        <div id="collapseVaccination" className="accordion-collapse collapse" aria-labelledby="headingVaccination" data-bs-parent="#sickAccordion">
                            <div className="accordion-body">

                                <div className="tabsBodySickle">
                                    <div className="patientProfileSickelMedication medicationFeilds">
                                        <div className="medicationFeildsRow">
                                            <div className="feild">
                                                <label>Vaccine Name</label>
                                                <select name="vaccine_id" onChange={fetchVaccineDose}>
                                                    <option value="">Select Vaccine</option>
                                                    {
                                                        vaccineNames && vaccineNames.map((item, index) => (
                                                            <option key={index} value={item.vaccine_id}>{item.vaccine_name}</option>
                                                        ))
                                                    }
                                                </select>
                                                {vaccineErrors.vaccine_id && <p style={{ color: 'red' }}>{vaccineErrors.vaccine_id}</p>}
                                            </div>
                                            <div className="feild field-19">
                                                <label>Date of vaccination</label>
                                                <input type="date" name="vaccination_date" onChange={vaccineInputChange}/>
                                                <p className="error-medicin">Minimum date: Confirmatory/Screening Result date(09-04-2025)</p>
                                                {vaccineErrors.vaccination_date && <p style={{ color: 'red' }}>{vaccineErrors.vaccination_date}</p>}
                                            </div>

                                            {vaccineDose && (
                                                <>
                                                    <div className="feild">
                                                        <label>Vaccine Dose</label>
                                                        <select name="dose_id" onChange={vaccineInputChange}>
                                                            <option value="">Select Dose</option>
                                                            {
                                                                vaccineDose && vaccineDose.map((item, index) => (
                                                                    <option key={index} value={item.dose_id}>{item.dose_name}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {vaccineErrors.dose_id && <p style={{ color: 'red' }}>{vaccineErrors.dose_id}</p>}
                                                    </div>
                                                    <div className="feild field-19">
                                                        <label>Date of Next Vaccination</label>
                                                        <input type="date" name="next_vaccine_date" onChange={vaccineInputChange}/>
                                                        {vaccineErrors.next_vaccine_date && <p style={{ color: 'red' }}>{vaccineErrors.next_vaccine_date}</p>}
                                                    </div>
                                                </>
                                            )}

                                            <div className="feild">
                                                <label>Vaccine Center Name</label>
                                                <select name="vaccination_hf_id" disabled={true}>
                                                    {/* <option>select</option> */}
                                                    <option value={"413399"}>Kanpur AMMS</option>
                                                </select>
                                                {vaccineErrors.vaccination_hf_id && <p style={{ color: 'red' }}>{vaccineErrors.vaccination_hf_id}</p>}
                                            </div>

                                        </div>
                                        <div className="ProceedtoTreatment">
                                            <h4>Vaccination Actions</h4>
                                            <div className="ProceedTreatmentAction">
                                                <button className="addMedication" onClick={addVaccine}>Add</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default DiseaseManagement
